import { makeAutoObservable, autorun } from 'mobx'
import { restaurantCenter, RESTAURANT_EVENT } from 'restaurant'

/** 菜单切换 */
class SwitchMenu {
  // 倒计时开始时间
  earlyTime: number=0;

  constructor () {
    makeAutoObservable(this)
    // 监听菜单切换事件
    restaurantCenter.on(RESTAURANT_EVENT.MENU_WILL_UPDATE, (time: number) => {
      this.setEarlyTime(Math.ceil(time / 1000))
    })
    // 监听菜单开始刷新
    restaurantCenter.on(RESTAURANT_EVENT.MENU_START, () => {
      this.setEarlyTime(0)
    })
  }

  setEarlyTime (earlyTime) {
    this.earlyTime = earlyTime
  }
}
const switchMenu = new SwitchMenu()
autorun(() => {
  if (switchMenu.earlyTime > 0) {
    setTimeout(() => {
      switchMenu.setEarlyTime(switchMenu.earlyTime - 1)
    }, 1000)
  }
})

export default switchMenu
